// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Wc4bi","right":"styles_right__3U89i"};